export function SectionTitle({
  title,
  subtitle,
  centered,
}: {
  title: string;
  subtitle?: string;
  centered?: boolean;
}) {
  return (
    <div className={centered ? "text-center" : ""}>
      <div className={`text-sm font-medium text-[--color-text-primary]`}>
        {title}
      </div>
      {subtitle ? (
        <div className={`mt-0.5 text-xs text-[--color-text-secondary]`}>
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}
